import { render, staticRenderFns } from "./GroupRoleReport.vue?vue&type=template&id=40db16ce"
import script from "./GroupRoleReport.vue?vue&type=script&lang=js"
export * from "./GroupRoleReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports